import { render, staticRenderFns } from "./personalPage.vue?vue&type=template&id=01b29818&scoped=true"
import script from "./personalPage.vue?vue&type=script&lang=js"
export * from "./personalPage.vue?vue&type=script&lang=js"
import style0 from "./personalPage.vue?vue&type=style&index=0&id=01b29818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b29818",
  null
  
)

export default component.exports